import { LeadsDataSource } from '../../../utils/apis/leadsApiUtils';
const totalLeadsTileConfigs = {
    [LeadsDataSource.DDC]: {
        titleMessage: (intl) => intl.formatMessage({
            id: 'TOTAL_LEADS_TILE_TITLE_DDC',
            defaultMessage: 'Total Leads - Dealer.com Dealership Website',
        }),
        descriptionMessage: (intl) => intl.formatMessage({
            id: 'TOTAL_LEADS_TILE_DESC_DDC',
            defaultMessage: 'Total Dealer.com Leads by Type',
        }),
        linkDescriptionMessage: (intl) => intl.formatMessage({
            id: 'TOTAL_LEADS_TILE_LINK_DESC_DDC',
            defaultMessage: 'Go to the Dealer.com Website Leads Data Insights Table',
        }),
        sourceMessage: (intl) => intl.formatMessage({
            id: 'SOURCE_NVISION',
            defaultMessage: 'nVision',
        }),
        view: 'ddcTotalLeads',
    },
    [LeadsDataSource.VIN_SOLUTIONS]: {
        titleMessage: (intl) => intl.formatMessage({
            id: 'TOTAL_LEADS_TILE_TITLE_VIN_SOLUTIONS',
            defaultMessage: 'Total Leads - VinSolutions CRM',
        }),
        descriptionMessage: (intl) => intl.formatMessage({
            id: 'TOTAL_LEADS_TILE_DESC_VIN_SOLUTIONS',
            defaultMessage: 'Total VinSolutions Leads by Type',
        }),
        linkDescriptionMessage: (intl) => intl.formatMessage({
            id: 'TOTAL_LEADS_TILE_LINK_DESC_VIN_SOLUTIONS',
            defaultMessage: 'Go to the VIN Solutions Leads Data Insights Table',
        }),
        sourceMessage: (intl) => intl.formatMessage({
            id: 'SOURCE_VIN_SOLUTIONS',
            defaultMessage: 'VinSolutions',
        }),
        view: 'vinTotalLeads',
    },
    [LeadsDataSource.ATKBB]: {
        titleMessage: (intl) => intl.formatMessage({
            id: 'TOTAL_LEADS_TILE_TITLE_ATKBB',
            defaultMessage: 'Total Leads - Autotrader / KBB Listings',
        }),
        descriptionMessage: (intl) => intl.formatMessage({
            id: 'TOTAL_LEADS_TILE_DESC_ATKBB',
            defaultMessage: 'Total Autotrader / KBB Leads by Type',
        }),
        linkDescriptionMessage: (intl) => intl.formatMessage({
            id: 'TOTAL_LEADS_TILE_LINK_DESC_ATKBB',
            defaultMessage: 'Go to the Autotrader / KBB Leads Data Insights Table',
        }),
        sourceMessage: (intl) => intl.formatMessage({
            id: 'SOURCE_NVISION',
            defaultMessage: 'nVision',
        }),
        view: 'atKbbTotalLeads',
    },
    [LeadsDataSource.ICO]: {
        titleMessage: (intl) => intl.formatMessage({
            id: 'TOTAL_LEADS_TILE_TITLE_ICO',
            defaultMessage: 'Total Leads - Instant Cash Offer',
        }),
        descriptionMessage: (intl) => intl.formatMessage({
            id: 'TOTAL_LEADS_TILE_DESC_ICO',
            defaultMessage: 'Total Instant Cash Offers by Source',
        }),
        linkDescriptionMessage: (intl) => intl.formatMessage({
            id: 'TOTAL_LEADS_TILE_LINK_DESC_ICO',
            defaultMessage: 'Go to the ICO Leads Data Insights Table',
        }),
        sourceMessage: (intl) => intl.formatMessage({
            id: 'SOURCE_NVISION',
            defaultMessage: 'nVision',
        }),
        view: 'icoTotalLeads',
    },
};
export default totalLeadsTileConfigs;
